"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FileList {
    constructor(controller, filePreviewRenderer) {
        this.controller = controller;
        this.filePreviewRenderer = filePreviewRenderer;
    }
    /**
     * Setup the file list UI, synchronizing with the controller.
     * This includes adding and removing files from the list.
     *
     * @returns {void}
     */
    init() {
        this.controller.onFileAdded((file) => {
            this.filePreviewRenderer.add(file);
        });
        this.controller.onFileRemoved((file) => {
            this.filePreviewRenderer.remove(file);
        });
    }
}
exports.default = FileList;
